import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * Injects a table caption post-fixer into the model.
 *
 * The role of the table caption post-fixer is to ensure that the table with caption have the correct structure
 * after a {@link module:engine/model/model~Model#change `change()`} block was executed.
 *
 * The correct structure means that:
 *
 * * If there are many caption model element, they are merged into one model.
 * * A final, merged caption model is placed at the end of the table.
 */
export default function injectTableCaptionPostFixer(model) {
  model.document.registerPostFixer(function (writer) {
    return tableCaptionPostFixer(writer, model);
  });
}
/**
 * The table caption post-fixer.
 */
function tableCaptionPostFixer(writer, model) {
  var changes = model.document.differ.getChanges();
  var wasFixed = false;
  var _iterator = _createForOfIteratorHelper(changes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      if (entry.type != 'insert') {
        continue;
      }
      var positionParent = entry.position.parent;
      if (positionParent.is('element', 'table') || entry.name == 'table') {
        var table = entry.name == 'table' ? entry.position.nodeAfter : positionParent;
        var captionsToMerge = Array.from(table.getChildren()).filter(function (child) {
          return child.is('element', 'caption');
        });
        var firstCaption = captionsToMerge.shift();
        if (!firstCaption) {
          continue;
        }
        // Move all the contents of the captions to the first one.
        var _iterator2 = _createForOfIteratorHelper(captionsToMerge),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var caption = _step2.value;
            writer.move(writer.createRangeIn(caption), firstCaption, 'end');
            writer.remove(caption);
          }
          // Make sure the final caption is at the end of the table.
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (firstCaption.nextSibling) {
          writer.move(writer.createRangeOn(firstCaption), table, 'end');
          wasFixed = true;
        }
        // Do we merged captions and/or moved the single caption to the end of the table?
        wasFixed = !!captionsToMerge.length || wasFixed;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return wasFixed;
}